import React, {Component} from 'react';
import { withRouter } from "react-router-dom";
import {BsyUtils} from "../../utils/Utils";

class ApiDocContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errlist:[]
        }
    }

    _genCode = (e, t) =>{
        if("json" === (t = t || "json")){
            e = JSON.stringify(e, null, 4);
        }
        return <pre><code className={t}>{e}</code></pre>
    }

    _genTable = (e) => {
        return <table className="api-table x-table-bordered x-table-striped">
            <tr>
                {
                    e.columns.map((res)=>{
                        return <th>{
                            res.text
                        }</th>
                    })
                }
            </tr>
            {
                e.data.map((res)=>{
                    return <tr>
                        {
                            e.columns.map((res1)=>{
                                return <td>{
                                    res[res1.key]
                                }</td>
                            })
                        }
                    </tr>
                })
            }
        </table>
    }

    _genUl = (e) => {
        return <ul className="api-ul">
            {
                e.map((res)=>{
                    return <li className="api-li">{res}</li>
                })
            }
        </ul>
    }

    _genApiTitle = (e, t, i, a) => {
        let url=i.url;
        url=url.replace(/:appId/g,e).replace(/:entryId/g,t);
        return <div className={"api-h1 " + a}>
            <h2>POST - </h2>
            <p>
                <input readOnly="readonly" style={{"width": "80%","font-size": "16px","border": "none","color": "#666","padding-left": 0}} type="text" value={url} />
                <a href="javascript:void(0)" className="copy" onClick={(event)=>{
                    event.currentTarget.previousSibling.select();
                    document.execCommand('Copy');
                }}>{React.language("click.copy")}</a>
            </p>
            <p>{i.name}</p>
            {
                i.desc && <div className="api-p">{i.desc}</div>
            }
        </div>
    }

    componentDidMount() {
        React.axios('/openapi/errlist',{}).then((res)=>{
            this.setState({errlist:res.data})
            document.getElementsByClassName("api-doc")[0].getElementsByClassName(this.props.match.params.type).length > 0 && document.getElementsByClassName("api-doc")[0].scrollTo(0,document.getElementsByClassName("api-doc")[0].getElementsByClassName(this.props.match.params.type)[0].offsetTop);
        })
        
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.match.params.type !== this.props.match.params.type){
            document.getElementsByClassName("api-doc")[0].getElementsByClassName(nextProps.match.params.type).length > 0 && document.getElementsByClassName("api-doc")[0].scrollTo(0,document.getElementsByClassName("api-doc")[0].getElementsByClassName(nextProps.match.params.type)[0].offsetTop) ;
        }
    }

    render() {
        const {errlist} = this.state;
        let s = this.props.match.params.id;
        let i = this.props.match.params.entryId;
        let n = this.props.match.params.type;
        let m = this.props.match.params.mode;
        let p = {};
        p.name = ""
        let t = "";
        var routUrl = window.root_directroy ? window.root_directroy + '/' : '';
        p.url = window._bby_config.api_site + routUrl +"openapi/v1/app/"+s+"/post";
        return (
            <div className="api-doc-content">
                <div className="api-h1 overview">
                    {
                        React.language("api.intro")
                    }
                </div>
                <div className="api-p">
                    {
                        React.language("api.overview")
                    }
                    {/* <a className="api-a" target="_blank" href={window._bby_config.help_link + '/doc/10541'}>
                        {
                            React.language("api.doc")
                        }
                    </a> */}
                </div>
                <div className="api-p">
                    {
                        React.language("api.rule")
                    }
                </div>
                {
                    this._genUl([React.language("api.rule.host") + " " + window._bby_config.api_site, React.language("api.rule.https"), React.language("api.rule.post"), React.language("api.rule.utf8"), React.language("api.rule.json")])
                }
                <div className="api-h1 limit">
                    {
                        React.language("api.limit")
                    }
                </div>
                <div className="api-p"><span className="api-e">{React.language("api.limit.num")}</span></div>
                <div className="api-h1 authorization">{React.language("api.auth")}</div>
                <div className="api-p" dangerouslySetInnerHTML={{__html:React.language("api.auth.token",{where:'<span class="api-e">' + React.language("api.auth.genTokenInAccount") + "</span>",button:'<span class="api-e">' + React.language("api.CeateKey") + "</span>",step1:'<span class="api-e">' + React.language("open.platform") + "</span>",step2:'<span class="api-e">' + React.language("key.management") + "</span>",step3:'<span class="api-e">' + React.language("webhook.key.create.tip") + "</span>",document:'<span class="api-e">' + React.language("api.doc") + "</span>"})}} />
                <div className="api-p">{React.language("api.auth.key.reset")}</div>
                <div className="api-p" dangerouslySetInnerHTML={{__html:React.language("api.auth.setHttpHeaders",{auth:'<span class="api-e">Authorization</span>',yourKey:'<span class="api-e">"Bearer YOUR_APIKEY"</span>'})}} />
                <div className="api-p">{React.language("api.auth.example")}</div>
                {
                    this._genCode("$ curl -i " + window._bby_config.api_site + 'openapi/v1 \\ \n   -H "Authorization: Bearer YOUR_APIKEY"', "bash")
                }
                <div className="api-p">{React.language("api.auth.warning")}</div>
                <div className="api-h1 errorCode">{React.language("api.error.table")}</div>
                <div className="api-p" dangerouslySetInnerHTML={{__html:React.language("api.error.table.tip",{code:'<span class="api-e">' + React.language("api.error.statusAndErrorCode") + "</span>",successCode:'<span class="api-e">2xx</span>',errorCode400:'<span class="api-e">400</span>',errorCode:'<span class="api-e">' + React.language("api.error.code") + "</span>",errorMessage:'<span class="api-e">' + React.language("api.error.message") + "</span>"})}} />
                {
                    this._genCode('HTTP/1.1 400\nContent-Type: application/json\n\n{\n   "code": 4004,\n   "message": '+React.language("api.error.8303")+'\n}', "http")
                }
                {
                    this._genTable({
                        columns: [{
                            key: "code",
                            text: React.language("api.error.statusCode")
                        }, {
                            key: "desc",
                            text: React.language("explain")
                        }],
                        data: [{
                            code: "2xx",
                            desc: React.language("api.res.success")
                        }, {
                            code: "400",
                            desc: React.language("api.error.res")
                        }]
                    })
                }
                <div className="api-p">{React.language("api.error.example")}</div>
                {
                    this._genTable({
                        columns: [{
                            key: "errcode",
                            text: React.language("api.error.code")
                        }, {
                            key: "errmessage",
                            text: React.language("explain")
                        }],
                        data: errlist
                    })
                }
                {m === "app" && <>
                    <div className="api-h1 postCode">{React.language("post.Code")}</div>
                    <div className="api-p">{this._genApiTitle(s, t, p, n)}</div>
                    <div className="api-p">{React.language("post.Code.tip2")}</div>
                    <div className="api-p">{React.language("post.Code.tip3")}</div>
                    {
                        this._genCode('{\n   "time": "20200603",\n   "action": "request",\n   "content": "this is local msg"\n}\n', "http")
                    }
                    <div className="api-p">{React.language("post.Code.tip4")}</div>
                    <div className="api-p">
                        _webapi(arg,info)
                        {
                            this._genTable({columns: [{
                                    key: "code",
                                    text: React.language("params")
                                }, {
                                    key: "desc",
                                    text: React.language("type")
                                }, {
                                    key: "explain",
                                    text: React.language("explain")
                                }],
                                data: [{
                                    code: "arg",
                                    desc: "array",
                                    explain:React.language("post.Code.tip5")
                                }, {
                                    code: "info",
                                    desc: "array",
                                    explain:React.language("post.Code.tip6")
                                }]
                            })
                        }
                    </div>
                    <div className="api-p" style={{"font-weight": "bold"}}>{React.language("post.Code.tip7")}</div>
                    <div className="api-p">{React.language("webApi.lua1")}</div>
                    {
                        this._genCode('function _webapi(arg,info)\n    arr = {}\n    arr["code"] = 200 // '+React.language("post.Code.tip8")+'\n    arr["msg"] = "接到消息" // '+React.language("post.Code.tip9")+'\n    return cjson.encode(arr)\nend', "http")
                    }
                    <div className="api-p">{React.language("webApi.python1")}</div>
                    {
                        this._genCode('def _webapi(arg,info):\n    arr = {}\n    arr["code"] = 200 # '+React.language("post.Code.tip8")+'\n    arr["msg"] = "接到消息" # '+React.language("post.Code.tip9")+'\n    return json.dumps(arr,ensure_ascii=False)', "http")
                    }
                    <div className="api-p">
                        {React.language("api.res.example")}
                        {
                            this._genCode('{\n   "code": 200,\n   "msg": "接到消息"\n}\n', "http")
                        }
                    </div>
                </>}
            </div>
        );
    }
}
export default withRouter(ApiDocContent)